import Vue from 'vue';

export const isMobile = () => {
  return process.client && window.innerWidth < 1024;
};

// 2022-04-21 추가
export const isBreakPoint = () => {
  return process.client && window.innerWidth < 758;
};

export const OS = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Window';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

// Make sure to pick a unique name to prevent memory leaks
if (!Vue.__computed_isBreakPoint_mixin__) {
  Vue.__computed_isBreakPoint_mixin__ = true;
  Vue.mixin({
    computed: {
      $$isBreakPoint() {
        // responsive screen size
        return isBreakPoint();
      },
    },
  });
}

if (!Vue.__computed_isMobile_mixin__) {
  Vue.__computed_isMobile_mixin__ = true;
  Vue.mixin({
    computed: {
      $$isMobile() {
        // responsive screen size
        return isMobile();
      },
    },
  });
}

if (!Vue.__computed_os_mixin__) {
  Vue.__computed_os_mixin__ = true;
  Vue.mixin({
    computed: {
      $$os() {
        return OS();
      },

      $$isAndroid() {
        return this.$$os == 'Android';
      },

      $$isIOS() {
        return this.$$os == 'iOS';
      },
    },
  });
}
